import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FileUpload} from 'primeng/fileupload';
import {ListaService} from '../../../../_services/lista.service';
import {NavService} from '../../../../_services/_nav.service';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {AppSettingService} from '../../../../_services/app-setting.service';
import {ProductoPasarelaTarifaService} from '../../../../_services/producto-pasarela-tarifa.service';
import {ProductoPasarelaTarifa} from '../../../../_models/producto-pasarela-tarifa';
import {CanalService} from '../../../../_services/canal.service';
import {AdjuntoService} from '../../../../_services/adjunto.service';
import {forkJoin, Observable} from 'rxjs';
import {Listas} from '../../../../_enums/enum';
import {ProductoPasarela} from '../../../../_models/producto-pasarela';
import {slideCollapseAnimation} from '../../../../utils/slide-collapse.animation';
import {CustomValidators} from '../../../../_helpers/formularios-reactivos/custom.validators';
import {AppSettings} from '../../../../../proyect.conf';

@Component({
  selector: 'app-producto-pasarela-tarifas',
  templateUrl: './producto-pasarela-tarifas.component.html',
  styleUrl: './producto-pasarela-tarifas.component.css',
  animations: [slideCollapseAnimation],
})
export class ProductoPasarelaTarifasComponent implements OnInit {
  @Input() isDetail: boolean = false;
  @Input() productoPasarela: ProductoPasarela;
  isLoading: boolean = true;
  records: ProductoPasarelaTarifa[] = [];
  channels: SelectItem[] = [];
  paymentMethods: SelectItem[] = [];
  cols: any[] = [];
  rows: number = 10;

  showForm: boolean = false;
  form: FormGroup;
  submitted: boolean = false;
  saving: boolean = false;
  cdKey: string = 'producto-pasarela-tarifas';

  svcThUrl: string = AppSettings.rutServiciosADJ + '/api/adjuntos';
  iconoPreview: SafeResourceUrl;
  nombreIcono: string;
  iconoArchivoSeleccionado: File;
  subiendoAdjunto: boolean = false;
  iconosBase64: { [idProductoPasarelaTarifa: string]: SafeResourceUrl } = {};
  @ViewChild('adjunto') adjunto: FileUpload;

  constructor(
    private fb: FormBuilder,
    private service: ProductoPasarelaTarifaService,
    private listService: ListaService,
    private canalService: CanalService,
    private navService: NavService,
    private confirmationService: ConfirmationService,
    private appSettingService: AppSettingService,
    private adjuntoService: AdjuntoService,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    this.cols = [
      {field: 'nombreCanal', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_CANAL'), sort: false},
      {field: 'nombreMedioPago', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MEDIO_PAGO'), sort: false},
      {field: 'tarifaTrxVentaPorcentaje', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_VENTA'), sort: false},
      {field: 'tarifaTrxIndividual', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_INDIVIDUAL'), sort: false},
      {field: 'montoMinimoTrx', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MINIMO'), sort: false},
      {field: 'montoMaximoTrx', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO'), sort: false},
      {field: 'montoMaximoMes', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO_MES'), sort: false},
      {field: 'limiteTrxDiario', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_DIARIO'), sort: false},
      {field: 'limiteTrxMes', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_MES'), sort: false},
      {
        field: 'indicadorAplicaTarifaEspecial',
        header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_APLICA_TARIFA_ESPECIAL'),
        sort: false
      },
      {
        field: 'indicadorAprobacionAutomatica',
        header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_APROBACION_AUTOMATICA'),
        sort: false
      },
      {field: 'nombreAdjuntoIcono', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_ICONO'), sort: false},
    ];

    if (!this.isDetail) {
      this.cols.push({field: 'acciones', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false});
    }

    this.loadData();
  }

  loadData(): void {
    forkJoin([
      this.service.getByIdProductoPasarelaEnabled(this.productoPasarela?.idProductoPasarela),
      this.canalService.listadoCanalesHabilitados(),
      this.listService.getMasterDetails(Listas.LISTAS_TIPOS_MEDIOS_PAGOS),
    ]).subscribe({
      next: ([records, channels, paymentMethods]) => {
        this.records = records;
        this.channels = channels.map(e => ({label: e.nombre, value: e.idCanal}));
        this.paymentMethods = paymentMethods.map(e => ({label: e.nombre, value: e.idLista}));
        this.isLoading = false;
        this.cargarIconos(records);
      },
    });
  }

  loadRecords(): void {
    this.isLoading = true;
    this.service.getByIdProductoPasarelaEnabled(this.productoPasarela?.idProductoPasarela).subscribe({
      next: (records) => {
        this.records = records;
        this.isLoading = false;
        this.form?.updateValueAndValidity();
        this.cargarIconos(records);
      },
    });
  }

  onCreateOrEdit(record?: ProductoPasarelaTarifa): void {
    this.buildForm(record);
  }

  onDelete(record: ProductoPasarelaTarifa): void {
    this.confirmationService.confirm({
      key: this.cdKey,
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      message: this.navService.buscarMensaje('MSG_ELIMINARCAMBIOS'),
      accept: () => {
        this.saving = true;
        record.indicadorHabilitado = false;
        this.service.update(record).subscribe({
          next: () => {
            this.navService.setMesage(2);
            this.saving = false;
            if (this.form && this.f.idProductoPasarelaTarifa.value === record.idProductoPasarelaTarifa) {
              this.showForm = false;
            }
            this.loadRecords();
          },
          error: () => {
            this.navService.setMesage(3);
            this.saving = false;
          },
        });
      },
    });
  }

  onCancel(): void {
    if (this.isFormDirty) {
      this.confirmationService.confirm({
        key: this.cdKey,
        header: this.navService.buscarMensaje('LBL_CAMBIOS_SIN_GUARDAR'),
        message: this.navService.buscarMensaje('MSG_CAMBIOS_SIN_GUARDAR'),
        accept: () => this.showForm = false,
      });
    } else {
      this.showForm = false;
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.subiendoAdjunto || this.form.invalid || this.iconoInvalido) {
      return;
    }

    this.saving = true;
    if (this.iconoArchivoSeleccionado) {
      this.subiendoAdjunto = true;
      this.adjunto.upload();
      return;
    }

    this.guardarRegistro();
  }

  private guardarRegistro(): void {
    const record: ProductoPasarelaTarifa = this.form.getRawValue();
    const request: Observable<ProductoPasarelaTarifa> = this.isNewRecord ? this.service.create(record) : this.service.update(record);
    request.subscribe({
      next: () => {
        this.navService.setMesage(this.isNewRecord ? 1 : 2);
        this.saving = false;
        this.showForm = false;
        this.loadRecords();
      },
      error: () => {
        this.navService.setMesage(3);
        this.saving = false;
      },
    });
  }

  get percentageSymbol(): string {
    return ` ${this.appSettingService.percentageSymbol}`;
  }

  get moneySymbol(): string {
    return `${this.appSettingService.simboloDinero} `;
  }

  get isNewRecord(): boolean {
    return !this.f.idProductoPasarelaTarifa.value;
  }

  get isFormDirty(): boolean {
    return this.showForm && !!this.form?.dirty;
  }

  get iconoInvalido(): boolean {
    return !this.f.idAdjuntoIcono.value && !this.iconoArchivoSeleccionado;
  }

  get f() {
    return this.form.controls;
  }

  private buildForm(record?: ProductoPasarelaTarifa): void {
    this.form = this.fb.group({
      idProductoPasarela: [record ? record.idProductoPasarela : this.productoPasarela?.idProductoPasarela],
      idProductoPasarelaTarifa: [record ? record.idProductoPasarelaTarifa : null],
      idCanal: [record ? record.idCanal : null, [Validators.required]],
      idMedioPago: [record ? record.idMedioPago : null, [Validators.required]],
      tarifaTrxVentaPorcentaje: [record ? record.tarifaTrxVentaPorcentaje : null, [Validators.required]],
      tarifaTrxIndividual: [record ? record.tarifaTrxIndividual : null, [Validators.required]],
      montoMinimoTrx: [record ? record.montoMinimoTrx : null, [Validators.required]],
      montoMaximoTrx: [record ? record.montoMaximoTrx : null, [Validators.required]],
      montoMaximoMes: [record ? record.montoMaximoMes : null, [Validators.required]],
      limiteTrxDiario: [record ? record.limiteTrxDiario : null, [Validators.required]],
      limiteTrxMes: [record ? record.limiteTrxMes : null, [Validators.required]],
      indicadorAplicaTarifaEspecial: [record ? record.indicadorAplicaTarifaEspecial : false],
      indicadorAprobacionAutomatica: [record ? record.indicadorAprobacionAutomatica : false],
      idAdjuntoIcono: [record ? record.idAdjuntoIcono : null],
      descripcion: [record ? record.descripcion : null, [Validators.maxLength(80)]],
      indicadorHabilitado: [record ? record.indicadorHabilitado : true],
    });

    if (this.isNewRecord) {
      this.form.setValidators(CustomValidators.uniqueCombination<ProductoPasarelaTarifa>(['idCanal', 'idMedioPago'], () => this.records));
    } else {
      this.f.idCanal.disable();
      this.f.idMedioPago.disable();
    }

    this.iconoPreview = null;
    this.iconoArchivoSeleccionado = null;
    this.nombreIcono = record?.nombreAdjuntoIcono;
    this.subiendoAdjunto = false;
    if (record?.idAdjuntoIcono) {
      this.cargarIcono(record.idAdjuntoIcono);
    }

    this.submitted = false;
    this.showForm = true;
  }

  /**
   * Descarga el adjunto del ícono y lo pinta como vista previa del formulario.
   * @param idAdjuntoIcono id del adjunto retornado por el microservicio de adjuntos.
   */
  private cargarIcono(idAdjuntoIcono: string): void {
    this.subiendoAdjunto = true;
    this.adjuntoService.descargarArchivo(idAdjuntoIcono).subscribe({
      next: (blob) => {
        this.subiendoAdjunto = false;
        if (!blob || blob.size === 0) {
          return;
        }
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.iconoPreview = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
        }, false);
        reader.readAsDataURL(blob);
      },
      error: () => {
        this.subiendoAdjunto = false;
      },
    });
  }

  /**
   * Descarga los íconos de las filas de la tabla y los indexa en iconosBase64.
   * @param records tarifas ya cargadas en la tabla.
   */
  private cargarIconos(records: ProductoPasarelaTarifa[]): void {
    records
      .filter((r) => !!r.idAdjuntoIcono)
      .forEach((r) => {
        this.adjuntoService.descargarArchivo(r.idAdjuntoIcono).subscribe((blob) => {
          if (!blob || blob.size === 0) {
            return;
          }
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.iconosBase64[r.idProductoPasarelaTarifa] = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
          }, false);
          reader.readAsDataURL(blob);
        });
      });
  }

  /**
   * Inyecta el metadato 'obj' en el FormData antes de que PrimeNG haga el POST del ícono.
   * @param event evento onBeforeUpload de p-fileUpload.
   */
  onBeforeUploadIcono(event: any): void {
    this.subiendoAdjunto = true;
    this.adjuntoService.cargarArchivo(event, this.nombreIcono, 'ProductoPasarelaTarifaIcono');
  }

  /**
   * Guarda localmente el archivo elegido y pinta su vista previa
   * @param event evento onSelect de p-fileUpload.
   */
  onSelectIcono(event: any): void {
    if (this.adjunto.msgs?.length) {
      this.navService.setMesageArray(this.adjunto.msgs);
      return;
    }
    const file = event.currentFiles?.[0];
    if (!file) {
      return;
    }
    this.iconoArchivoSeleccionado = file;
    this.nombreIcono = file.name;
    this.form.markAsDirty();
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.iconoPreview = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
    }, false);
    reader.readAsDataURL(file);
  }

  /**
   * Guarda el idAdjunto devuelto por el microservicio y continúa con el
   * guardado del registro de la tarifa.
   * @param event evento onUpload de p-fileUpload.
   */
  onUploadIcono(event: any): void {
    const respuesta = event.originalEvent.body;
    this.f.idAdjuntoIcono.setValue(respuesta && respuesta.idAdjunto ? respuesta.idAdjunto : null);
    this.iconoArchivoSeleccionado = null;
    this.subiendoAdjunto = false;
    this.guardarRegistro();
  }

  /**
   * Maneja el error HTTP de subida del ícono, deja el archivo elegido para reintentar.
   */
  onErrorUploadIcono(): void {
    this.subiendoAdjunto = false;
    this.saving = false;
    this.navService.setMesage(3);
  }

  /** Limpia el ícono seleccionado del formulario. */
  eliminarIcono(): void {
    this.f.idAdjuntoIcono.setValue(null);
    this.iconoArchivoSeleccionado = null;
    this.iconoPreview = null;
    this.nombreIcono = null;
    this.adjunto?.clear();
  }

}
